module.exports = "li {\n    text-align: center;\n    color: floralwhite;\n    list-style-type: none;\n}\n\np.pTitle {\n    text-align: center !important;\n    color: white;\n}\n\nul {\n    margin-bottom: .1em !important;\n}\n\ntd {\n    color: burlywood;\n}\n\n.bigSearchResults {\n    -webkit-box-pack: left;\n        -ms-flex-pack: left;\n            justify-content: left;\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/searchy-search/searchy-search.component.css
// module id = ./src/app/searchy-search/searchy-search.component.css
// module chunks = main